/* modules imports */
import styled, { keyframes } from "styled-components";

/* project files imports */
import { devices } from "constants/style";

const fadeIn = keyframes`
  100% { opacity: 1; }
`;

/*
 * the space under the text matches the 30px above it (login page row-gap):
 * the card title sits at the bottom of a 45px box, with a 1.15 line height
 */
export const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: calc(30px - (45px - 1.15 * 14px));

  @media ${devices.sm} { row-gap: calc(30px - (45px - 1.15 * 16px)); }
  @media ${devices.lg} { row-gap: calc(30px - (45px - 1.15 * 18px)); }
`;

export const Text = styled.span`
  max-width: 340px;
  font-size: 16px;
  text-align: center;
  opacity: 0;
  animation: ${fadeIn} .15s forwards;
  animation-delay: .15s;

  @media ${devices.sm} {
    max-width: 450px;
    font-size: 18px;
  }

  @media ${devices.lg} {
    max-width: 600px;
    font-size: 20px;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 8px;

  /* on mobile, the card buttons are stacked and overflow below the card */
  margin-bottom: 60px;

  @media ${devices.sm} {
    column-gap: 20px;
    margin-bottom: 0;
  }

  @media ${devices.lg} { column-gap: 35px; }
`;
